import sortThreadBranchesByLatestActivity from '@/lib/threads/sortThreadBranchesByLatestActivity.js';

const buildChronologicalThreadSection = ({ sections = [], sortBy = 'updated' } = {}) => {
  return {
    id: 'threads',
    isActive: false,
    isHome: true,
    label: 'Tasks',
    projectId: null,
    sourceSectionIds: sections.map((section) => String(section?.id || section?.projectId || '').trim()).filter(Boolean),
    threadItems: sortThreadBranchesByLatestActivity({
      items: sections.flatMap((section) => section?.threadItems || []),
      sortBy
    })
  };
};

export default buildChronologicalThreadSection;
